exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2vvejMth0nrkGXSLrTei-7 {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n._30CLUeXqNh-s2j3l5O_-Pc {\n  justify-content: flex-end;\n}\n", "", {"version":3,"sources":["/home/forge/qa.leadpm.io/frontend/src/Screens/SubProject/Components/SubProjects/Components/Table/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;CACjB;;AAED;EACE,0BAA0B;CAC3B","file":"styles.css","sourcesContent":[".column {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.numeric {\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"column": "_2vvejMth0nrkGXSLrTei-7",
	"numeric": "_30CLUeXqNh-s2j3l5O_-Pc"
};